import { createSelector } from "@ngrx/store";
import { AppState } from "../reducers";

const instructionDetailsFeature = (state: AppState) => state.instructionDetails;

export const myInstruction = createSelector(
  instructionDetailsFeature,
  (state) => ({
    myInstruction: state.myInstruction,
    isLoadingMyInstruction: state.isLoadingMyInstruction,
    myInstructionConfirmation: state.myInstructionConfirmation,
  }),
);

export const myInstructionConfirmation = createSelector(
  instructionDetailsFeature,
  (state) => ({
    myInstructionConfirmation: state.myInstructionConfirmation,
    isLoadingMyInstructionConfirmation:
      state.isLoadingMyInstructionConfirmation,
  }),
);

export const chapters = createSelector(instructionDetailsFeature, (state) => ({
  chapters: state.chapters,
  isLoadingChapters: state.isLoadingChapters,
  chapterConfirmations: state.chapterConfirmations,
  isConfirmingChapter: state.isConfirmingChapter,
  isLoadingChapterConfirmations: state.isLoadingChapterConfirmations,
}));

export const questions = createSelector(instructionDetailsFeature, (state) => ({
  isLoadingQuestions: state.isLoadingQuestions,
  questions: state.questions,
}));

export const selectedChapter = createSelector(
  instructionDetailsFeature,
  (state) => ({
    selectedChapter: state.selectedChapter,
  }),
);

export const selectedChapterAndInstructionConfirmation = createSelector(
  instructionDetailsFeature,
  (state) => ({
    myInstructionConfirmation: state.myInstructionConfirmation,
    selectedChapter: state.selectedChapter,
  }),
);
